import { createRouter, createWebHashHistory, Router, RouteRecordRaw } from "vue-router"
import beforeEach from "@/router/beforeEach"
import afterEach from "@/router/afterEach"
import { renderRoutes as MobileRenderRoute } from "@/router/mobileRender"
import { renderRoutes as DesktopRenderRoute } from "@/router/desktopRender"
import { QueryInItInfoResponse } from "@/types/queryInitInfo"
import { tryReloadOnChunkError } from "@/utils/chunkLoad"
import {
  parseFromUrl,
  removeParseFromUrl,
  INITIAL_REDIRECT_SESSION_KEY
} from "@/utils/initialRedirect"
import { safeSessionStorage } from "@/utils/safeStorage"

const isMobile = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )

const initializeRouter = (router: Router, routes: RouteRecordRaw[]) => {
  routes.forEach(route => {
    router.addRoute(route)
  })
}

const renderRoutes = (
  router: Router,
  { optional }: { optional: QueryInItInfoResponse }
) => {
  const parseInfo = parseFromUrl()
  const { eventType } = parseInfo

  const routes = isMobile()
    ? MobileRenderRoute({ ...optional, eventType })
    : DesktopRenderRoute({ ...optional, eventType })

  initializeRouter(router, routes)

  safeSessionStorage.setItem(INITIAL_REDIRECT_SESSION_KEY, JSON.stringify(parseInfo))

  removeParseFromUrl()
}

const router = createRouter({
  history: createWebHashHistory("/"),
  routes: []
})

router.beforeEach(beforeEach)
router.afterEach(afterEach)

router.onError(error => {
  tryReloadOnChunkError(error.message)
})

export { renderRoutes }
export default router
